import { css } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const getLinkStyles = () =>
    css({
        display: 'flex',
        alignItems: 'center',
    });

export const getIconStyles = (theme: Theme) =>
    css({
        marginRight: theme.spacing(),
    });

export const getMainStyles = (theme: Theme) =>
    css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(2),
        backgroundColor: theme.palette.gray.ultraLight,
        overflow: 'auto',
        boxSizing: 'border-box',
    });

export const getContentStyles = (theme: Theme) =>
    css({
        maxWidth: 880,
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
    });

export const getEmailHeaderStyles = (theme: Theme) =>
    css({
        backgroundColor: theme.palette.white,
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(),

        [theme.mediaQuery('tablet')]: {
            flexDirection: 'row',
            gap: theme.spacing(3),
        },
    });

export const getEmailContentStyles = (theme: Theme) =>
    css({
        backgroundColor: theme.palette.white,
        padding: theme.spacing(2),
        display: 'flex',
        flexDirection: 'column',
        // To match email styles
        fontFamily: 'arial',
        color: '#717171',
    });

export const getGreetingStyles = (theme: Theme) =>
    css({
        fontWeight: theme.typography.fontWeight.normal,
        marginBottom: theme.spacing(3),
    });

export const getHeaderLabelStyles = (theme: Theme) =>
    css({
        marginRight: theme.spacing(0.5),
    });

export const getMessageStyles = (theme: Theme) =>
    css({
        marginBottom: theme.spacing(5),
    });

export const getDateStyles = (theme: Theme) =>
    css({
        // To match email styles
        color: '#8bce8f',
        fontWeight: theme.typography.fontWeight.bold,
    });

export const getRowStyles = (theme: Theme) =>
    css({
        display: 'flex',
        gap: theme.spacing(2),
        justifyContent: 'space-between',
        flexDirection: 'column',
        marginBottom: theme.spacing(3),

        [theme.mediaQuery('tablet')]: {
            flexDirection: 'row',
        },
    });

export const getContentBlockStyles = () =>
    css({
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
    });

export const getButtonWrapperStyles = (theme: Theme) =>
    css({
        display: 'flex',
        justifyContent: 'center',
        margin: `${theme.spacing(4)}px 0 ${theme.spacing(5)}px 0`,
    });

export const getButtonStyles = () =>
    css({
        // To match email styles
        backgroundColor: '#268aff',
        ':hover': {
            backgroundColor: '#268aff',
        },
    });

export const getDividerStyles = (theme: Theme) =>
    css({
        borderTopColor: theme.palette.gray.ultraLight,
        borderTopWidth: 6,
        marginBottom: theme.spacing(4),
    });

export const getPoweredStyles = (theme: Theme) =>
    css({
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        marginBottom: theme.spacing(3),
    });

export const getLogosStyles = (theme: Theme) =>
    css({
        display: 'flex',
        marginTop: theme.spacing(),
        gap: theme.spacing(2),
    });
export const getLogoStyles = () =>
    css({
        height: 35,
    });
